import { AutogenLayoutRateConfirmationViewer } from "./autogen/AutogenLayoutRateConfirmationViewer";

export class RateConfirmationViewer extends AutogenLayoutRateConfirmationViewer {

}
